import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';

import { Dialog } from '../../../../common/components/Dialog/Dialog';
import Button from '../../../../common/components/Button/Button';
import ChargerTaskForm, { DEFAULT_STATE, validate } from '../../../../common/components/ChargerTaskForm';

function ChargerTaskCreatingDialog(props) {
  const { isOpen, close, alert, chargerId, defaultState = DEFAULT_STATE, save } = props;
  const [state, setState] = useState({
    formState: defaultState,
    error: '',
    fieldErrors: [],
    loading: false,
  });
  const { formState, error, fieldErrors, loading } = state;

  const onChange = (event) => {
    const { name, value, checked, type } = event.target;
    let fieldValue = value;

    if (type === 'checkbox') fieldValue = checked;

    setState({
      ...state,
      error: '',
      formState: { ...state.formState, [name]: fieldValue },
    });
  };

  const onSave = () => {
    const error = validate(state.formState);

    if (!error) {
      setState({ ...state, error: '', loading: true });

      save(state.formState)
        .then(() => {
          setState({ ...state, loading: false });
          close();
          alert('The task has been created successfully');
        })
        .catch((err) => {
          console.error(err);
          setState({
            ...state,
            error: "Couldn't create a task, something went wrong",
            loading: false,
          });
        });
    } else {
      // Scroll to error on mobile
      setTimeout(() => document.querySelector('.MuiDialogContent-root').scrollTo(0, 2000), 0);

      setState({ ...state, error });
    }
  };

  const actions = [
    <Button key="cancel-btn" disabled={loading} onClick={close}>
      Cancel
    </Button>,
    <Button key="create-btn" disabled={loading} onClick={onSave} color="primary">
      {loading && (
        <>
          <CircularProgress size="10px" />
          &nbsp;
        </>
      )}{' '}
      Create
    </Button>,
  ];

  return (
    <Dialog actions={actions} title="New Task" open={isOpen} modal onClose={close}>
      <ChargerTaskForm
        error={error}
        fieldErrors={fieldErrors}
        chargerId={chargerId}
        defaultState={defaultState}
        currentState={formState}
        onChange={onChange}
      />
    </Dialog>
  );
}

export default ChargerTaskCreatingDialog;
